/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ApiConfig} from '../config/api-config';
import {EXECUTION_STATUS} from '../common/constants/resource-constants';
import {Uuid} from '../../components/util/uuid';
import {AdnApiClientService} from '../common/controller/adn-api-client.service';

@Injectable({providedIn: 'root'})
export class DiagnosticRequestApiService {
  private readonly uri = this.apiConfig.getVersionedUri('diagnosticrequests');

  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  start(params: Record<string, any>): Observable<any> {
    const request = {id: Uuid.generate(), ...params};
    return this.client.request({
      method: 'POST',
      url: this.itemUri(request.id),
      body: request
    });
  }

  get(id: string): Observable<any> {
    return this.client.request({
      method: 'GET',
      url: this.itemUri(id),
      params: {}
    });
  }

  isCompleted(execution: any): boolean {
    return execution.status === EXECUTION_STATUS.completed;
  }

  inProgress(execution: any): boolean {
    return [
      EXECUTION_STATUS.pending,
      EXECUTION_STATUS.queued,
      EXECUTION_STATUS.processing,
      EXECUTION_STATUS.submitted
    ].includes(execution.status);
  }

  private itemUri(id: string): string {
    return this.uri + '/' + encodeURIComponent(id);
  }
}
